// Denver
export const DEFAULT_LOCATION: google.maps.LatLngLiteral = {
  lat: 39.742043,
  lng: -104.991531,
};
